export class GameConstants {

    public static readonly DEVELOPMENT = false;
    public static readonly SKIP_ROTATION = false;
    public static readonly VERBOSE = false;
    public static readonly GAME_WIDTH = 1125;
    public static readonly GAME_HEIGHT = 1500;
}
